import { Button, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useState, useEffect } from "react";
import { login } from "../authContext/apiCalls";
import { AuthContext } from "../authContext/AuthContext";
import Container from '@mui/material/Container';
import LoginError from './LoginError';

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(true);
  const { dispatch, error, errorMessage } = useContext(AuthContext);

  const handleLogin = async(e) => {
    e.preventDefault();
    login({ username, password }, dispatch);
  };
  useEffect(() => {
    const validate = async() => {
      setDisabled(username.trim().length === 0 || password.trim().length === 0)
    };
    validate();
  },[username, password]);

  return (
    <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
        <Box p={2} flexDirection="column" sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '70vh',
      }}>
          <h1 align="center">Sign In</h1>
          <TextField 
              type="text"
              label="Username"
              margin="normal" 
              autoFocus
              onChange={(e) => setUsername(e.target.value)}
              sx={{width:"15vw"}}
          />
          <TextField 
              type="password"
              label="Password"
              margin="normal" 
              onChange={(e) => setPassword(e.target.value)}
              sx={{width:"15vw"}}
          />
          <Button margin="normal" onClick={handleLogin} variant="contained" size="large" disabled={disabled}>
            Sign In
          </Button>  
          <LoginError error={error} errorMessage={errorMessage}/>
        </Box>
    </Container>
  );
}
